import { isDesktop } from 'react-device-detect';
import Header from '../../components/Header/Header';
import styles from './Login.module.scss';
import loginBack from '../../assets/loginBack.png';
import userIcon from '../../assets/userIcon.png';
import passwordIcon from '../../assets/passwordIcon.png';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosClient from '../../libs/axiosClient';
import { setToken } from '../../auth/auth';
import { handleRedirectUrlCheck } from '../../common/redirectUrlCheck';
import { useTranslation } from 'react-i18next';
import { GOOGLE_AUTH_URL } from '../../auth/Google';
import { FACEBOOK_AUTH_URL } from '../../auth/Facebook';
import apple from '../../assets/appleLogo.png';
import google from '../../assets/googleLogo.png';
import facebook from '../../assets/facebookLogo.png';
import { handleAppleLogin } from '../../auth/Apple';

function Login() {
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  let redirectURL = new URLSearchParams(location.search).get('rurl');
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    axiosClient
      .post(
        '/func/user/login',
        {
          id: id,
          password: pw,
        },
        { withCredentials: true },
      )
      .then((res) => {
        setToken(res.data);
        if (handleRedirectUrlCheck(redirectURL || '/'))
          navigate(redirectURL || '/');
        else navigate('/');
      })
      .catch((err) => {
        alert(err.response.data.detail);
      });
  }

  const { t, i18n } = useTranslation();

  return (
    <div className={`${styles.container} ${!isDesktop && styles.isMobile}`}>
      {isDesktop && <Header />}
      {!isDesktop && (
        <div className={styles.backBtn} onClick={() => navigate(-1)}>
          <img src={loginBack} alt="backBtn" />
        </div>
      )}
      <div className={styles.contentWrap}>
        <h2 className={styles.title}>{t('login.1')}</h2>
        <form onSubmit={(e) => handleSubmit(e)} className={styles.loginForm}>
          <div className={styles.socialLoginWrap}>
            <div
              className={styles.facebookLoginWrap}
              onClick={() => {
                localStorage.setItem('rurl', redirectURL || '/');
                window.location.href = FACEBOOK_AUTH_URL;
              }}
            >
              <img src={facebook} alt="facebook" />
              <span>Sign in with Facebook</span>
            </div>
            <div
              className={styles.appleLoginWrap}
              onClick={() => {
                localStorage.setItem('rurl', redirectURL || '/');
                handleAppleLogin();
              }}
              // onClick={handleAppleLogin}
            >
              <img src={apple} alt="apple" />
              <span>Sign in with Apple</span>
            </div>
            <div
              className={styles.googleLoginWrap}
              onClick={() => {
                localStorage.setItem('rurl', redirectURL || '/');
                window.location.href = GOOGLE_AUTH_URL;
              }}
            >
              <img src={google} alt="google" />
              <span>Sign in with Google</span>
            </div>
            <p className={styles.helpText}>
              If you're having trouble with Google login, please try using a
              different web browser, <br />
              such as{' '}
              <a
                href="https://www.google.com/chrome/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Chrome
              </a>{' '}
              or{' '}
              <a
                href="https://www.microsoft.com/edge"
                target="_blank"
                rel="noopener noreferrer"
              >
                Microsoft Edge
              </a>
              .
            </p>
            <div className={styles.or}>
              <div></div>
              <span>OR</span>
              <div></div>
            </div>
          </div>
          <div className={styles.inputWrap}>
            <img src={userIcon} alt="userIcon" />
            <input
              type="text"
              value={id}
              onChange={(e) => setId(e.currentTarget.value)}
              onBlur={() => setId((prev) => prev.trim())}
              placeholder={`${t('login.2')}`}
            />
          </div>
          <div className={styles.inputWrap}>
            <img src={passwordIcon} alt="passwordIcon" />
            <input
              type="password"
              value={pw}
              onChange={(e) => setPw(e.currentTarget.value)}
              onBlur={() => setPw((prev) => prev.trim())}
              placeholder={`${t('login.3')}`}
            />
          </div>
          <button className={styles.loginBtn}>{t('login.1')}</button>
        </form>
        <ul className={styles.menu}>
          <li onClick={() => navigate('/findAccount?tab=0')}>{t('login.4')}</li>
          <li onClick={() => navigate('/findAccount?tab=1')}>{t('login.5')}</li>
          <li onClick={() => navigate('/join')}>{t('login.6')}</li>
        </ul>
      </div>
    </div>
  );
}
export default Login;
